export class BaseTemplateData {
  open_button: OpenButtonData;
  page_desc?: PageDesc;

  constructor(button: OpenButtonData, page_desc?: PageDesc) {
    this.open_button = button;
    this.page_desc = page_desc;
  }
}

export class Template000Data extends BaseTemplateData {
  constructor(button: OpenButtonData, page_desc?: PageDesc) {
    super(button, page_desc);
  }
}

export class Template001Data extends BaseTemplateData {
  title: string;
  head_color: string;
  img_src: string;
  introduction: string;
  desc: Array<string>;

  constructor(
    t: string,
    h_c: string,
    img: string,
    intro: string,
    desc: Array<string>,
    button: OpenButtonData,
    page_desc?: PageDesc,
  ) {
    super(button, page_desc);
    this.title = t;
    this.head_color = h_c;
    this.img_src = img;
    this.introduction = intro;
    this.desc = desc;
  }
}

export class Template002Data extends BaseTemplateData {
  img_src: string;

  constructor(img: string, button: OpenButtonData, page_desc?: PageDesc) {
    super(button, page_desc);
    this.img_src = img;
  }
}

export class Template003Data extends BaseTemplateData {
  img0: string;
  img1: string;
  img2: string;
  img3: string;

  constructor(
    img0: string,
    img1: string,
    img2: string,
    img3: string,
    button: OpenButtonData,
    page_desc?: PageDesc,
  ) {
    super(button, page_desc);
    this.img0 = img0;
    this.img1 = img1;
    this.img2 = img2;
    this.img3 = img3;
  }
}

export class Template004Data extends BaseTemplateData {
  img0: string;
  img1: string;
  img2: string;
  img3: string;

  constructor(
    img0: string,
    img1: string,
    img2: string,
    img3: string,
    button: OpenButtonData,
    page_desc?: PageDesc,
  ) {
    super(button, page_desc);
    this.img0 = img0;
    this.img1 = img1;
    this.img2 = img2;
    this.img3 = img3;
  }
}

export interface OpenButtonData {
  content: string;
  width: string;
  height: string;
  text_color: string;
  text_size: string;
  bg_color: string;
  position: ButtonPosition;
  radius: string;
  offset: string;
}

export interface PageDesc {
  title: string;
  desc: string;
  icon: string;
}

export enum ButtonPosition {
  TOP = 1,
  BOTTOM,
  CENTER,
}

export enum TemplateStyle {
  TemplateStyle000 = 0,
  TemplateStyle001,
  TemplateStyle002,
  TemplateStyle003,
  TemplateStyle004,
}
